import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
import { ConfigService } from 'src/services/config.service';
import { AuthStore } from 'src/app/store/authorization/auth.store';
import { SHARED_IMPORTS } from 'src/app/shared/shared.module';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-lsr-participant-header',
  templateUrl: './participant-header.component.html',
  styleUrls: ['./participant-header.component.css'],
  standalone: true,
  imports: [...SHARED_IMPORTS,RouterModule]
})
export class ParticipantHeaderComponent implements OnInit {
  hcontact$: Observable<string>;
  isAdminUser = false;
  isPrivacyPolicyPage = false;
  isPrivacyPolicyFormPage = false;
  isUnauthorizedUserPage = false;
  private readonly authStore = inject(AuthStore);
  private readonly router = inject(Router);

  constructor(private configService: ConfigService) {
    this.isAdminUser = this.authStore.isAdmin();
    this.hcontact$ = this.configService.getConfig$().pipe(
      map(configModel => configModel?.getConfigkeyname('Header_Contact') ?? '')
    );
  }

  ngOnInit() {
    this.isPrivacyPolicyPage = this.router.url.includes('privacypolicy');
    this.isPrivacyPolicyFormPage = this.router.url.includes('privacypolicyform');
    this.isUnauthorizedUserPage = this.router.url.includes('unauthorized-user');
  }

  get showHeaderActions(): boolean {
    return !this.isPrivacyPolicyPage && !this.isPrivacyPolicyFormPage && !this.isUnauthorizedUserPage;
  }

  get telLink(): string {
    return `tel:${this.hcontact$ || ''}`;
  }

  redirectToAdmin(event: Event) {
    event.preventDefault();
    window.location.href = `${AppConfig.appsettings.navigatorRoot}admin`;
  }

  scrollToAvailableStudies(event: Event) {
    event.preventDefault();
    const studySection = document.getElementById('study');

    if (studySection) {
      // Already on home page, scroll to the section
      studySection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      // Not on home page, navigate to home first, then scroll
      this.router.navigate(['/']).then(() => {
        // Wait for DOM to render after navigation
        setTimeout(() => {
          const section = document.getElementById('study');
          if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 300);
      });
    }
  }
}
